package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ChatSingleMessageModel(
    val role: String,
    val content: ChatContentModel,
    @SerialName("free_tokens")
    val freeTokens: Long? = null,
    @SerialName("premium_tokens")
    val premiumTokens: Long? = null
)
